// Поле поиска тикера с выпадающим списком результатов (контекстное меню под полем).
// Результаты рендерит сервер (CompanySearchController по data-href контрола) на каждый
// ввод; попап открывается только когда в поле есть текст.
class CompanySearch extends Tango.Component {
	getInput(el) {
		var inp = el instanceof HTMLInputElement;
		if (!inp)
			inp = el.querySelector('input');
		return inp;
	};

	widgetDidMount() {
		const _this = this;
		const ctrl = document.getElementById(this.root);
		var popupid = ctrl.getAttribute('data-popup');
		if (!popupid) popupid = this.root + '_popup';
		const popup = document.getElementById(popupid);
		if (!popup)
			return;
		const items = popup.getElementsByTagName('a');
		var selectedItem = null;

		const args = {
			triggerOn: 'keyup focus click',
			displayAround: 'triggerbottom',
			delayedTrigger: true,
			beforeOpen: function (data, event) {
				// data.trigger — DOM-элемент: contextmenu.js больше не отдаёт jQuery-обёртку,
				// так что старое data.trigger[0] давало undefined и рушило обработчик.
				var el = data.trigger;
				var inp = _this.getInput(el);

				if (!Tango.isMobile()) {
					if (inp && getComputedStyle(inp).getPropertyValue('display') != 'none') {
						if (inp.value == '') return 1;
						if (event.keyCode == 38 || event.keyCode == 40) return 2;
					}
					selectedItem = null;
				}
				return 0;
			},
			onOpen: function (data, event) {
				if (Tango.isMobile()) {
					body.classList.add('lock-position-body');
				}
				return ajaxUtils.runEventFromElementWithApiResponse(ctrl, { data: { resultid: popupid } });
			},
			afterOpen: function (data, event) {
				if (Tango.isMobile()) {
					data.trigger.scrollIntoView();
					window.scrollTo(0, 0);
				}
			},
			closeOnClick: true,
			closeOnClickSelector: function (el) {
				const b = !Tango.isMobile() || el.closest('.btn-close') || el.closest('a');
				if (el.closest('.btn-close') || el.closest('a'))
					body.classList.remove('lock-position-body');
				if (b) {
					var inp = _this.getInput(ctrl);
					inp.value = '';
				}
				return b
			},
			closeOnScroll: false,
			closeOnResize: false,
			width: 'trigger'
		};

		attachContextMenu(ctrl, popupid, args);

		const onKeyDown = function (e) {
			const el = e.currentTarget;
			if (!el.classList.contains("iw-opened")) return;
			var x = 0;
			if (e.keyCode == 13) {
				// Строка результата бывает и навигационной ссылкой, и AJAX-событием
				// (fundamentalchart: PostBackLink с onclick). click() прогоняет её через
				// те же обработчики, что и мышь, — а runHrefWithApiResponse ломал бы
				// событийные строки FAKEGET-запросом с changeloc.
				if (items[selectedItem]) items[selectedItem].click();
				$(el).val(null);
				e.preventDefault();
				return;
			}
			else if (e.keyCode == 38)
				x = -1;
			else if (e.keyCode == 40)
				x = 1;
			else
				return;
			e.preventDefault();
			if (selectedItem != null) items[selectedItem].className = '';
			selectedItem = selectedItem == null ? (x == 1 ? 0 : (items.length - 1)) : ((selectedItem + x) % items.length);
			selectedItem = selectedItem < 0 ? items.length + selectedItem : selectedItem;
			$(el).val(items[selectedItem].firstChild.innerText || items[selectedItem].firstChild.textContent);
			items[selectedItem].className = 'selected';
		}

		$(ctrl).keydown(onKeyDown);
	}
}

Tango.registerComponent(CompanySearch);
